// Exports the "charmap" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/charmap')
//   ES2015:
//     import 'tinymce/plugins/charmap'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/charmap/index.js
// module id = 1214
// module chunks = 0